import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import logo from "../assets/Asset 1.png";
import image from "../assets/header.png";
import mapAz from "../assets/map_AZ.pdf";
import mapEn from "../assets/map_EN.pdf";
import { useTranslation } from "react-i18next";

const Header = ({ changeLanguage }) => {
  const { t } = useTranslation();
  const [activeLang, setActiveLang] = useState("en");

  const handleLanguageChange = (lang) => {
    setActiveLang(lang);
    changeLanguage(lang);
  };

  // Define styles for the buttons
  const buttonStyle = {
    backgroundColor: "transparent",
    color: "var(--ocean-teal-3)",
    border: "1px solid var(--ocean-teal-3)",
  };

  const activeButtonStyle = {
    backgroundColor: "#083943",
    color: "var(--ocean-teal-3)",
  };

  return (
    <header style={{ padding: "0" }}>
      <Container fluid>
        <Row
          className="align-items-center top-header"
          style={{
            backgroundImage: "linear-gradient(to right,  #D2EAD5 ,#016871)",
            color: "white",
            padding: "1rem 5rem",
          }}
        >
          <Col xs={6}>
            <a href="https://cop29.az/en" target="_blank" rel="noreferrer">
              <img
                src={logo}
                alt="Logo"
                style={{ height: "auto", maxHeight: "50px" }}
              />
            </a>
          </Col>
          <Col xs={6} className="text-end">
            <Button
              variant="secondary"
              className="me-2"
              style={
                activeLang === "en"
                  ? { ...buttonStyle, ...activeButtonStyle }
                  : buttonStyle
              }
              onClick={() => handleLanguageChange("en")}
            >
              EN
            </Button>
            <Button
              variant="secondary"
              style={
                activeLang === "az"
                  ? { ...buttonStyle, ...activeButtonStyle }
                  : buttonStyle
              }
              onClick={() => handleLanguageChange("az")}
            >
              AZ
            </Button>
          </Col>
        </Row>
        <Row
          className="bottom-header"
          style={{ position: "relative", height: "400px" }}
        >
          <Col
            className="background-image-container"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              padding: "0",
              zIndex: 1,
            }}
          >
            <img
              src={image}
              alt="Background"
              className="background-image"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Col>
          <Col
            className="ms-2 text-content-container"
            style={{
              position: "relative",
              zIndex: 2,
              padding: "2rem",
              color: "white",
              height: "100%",
            }}
          >
            <div
              className="text-content"
              style={{ paddingLeft: "4rem", paddingRight: "2rem" }}
            >
              <h1
                className="pb-3 h1-weight"
                style={{ maxWidth: "70%", color: "#D2EAD5" }}
              >
                {t("header.title")}
              </h1>
              <p style={{ maxWidth: "50%", fontSize: "120%" }}>
                {t("header.subtitle")}
              </p>
              <p style={{ maxWidth: "50%", fontSize: "120%" }}>
                {t("header.guide1")}{" "}
                <a
                  href={activeLang === "az" ? mapAz : mapEn}
                  download={
                    activeLang === "az"
                      ? "Media Accreditation Portal_AZE"
                      : "Media Accreditation Portal_ENG"
                  }
                  style={{ color: "white" }}
                >
                  <b>{t("header.guide2")}</b>
                </a>
                {t("header.guide3")}
              </p>
              <p
                className="bolder"
                style={{ maxWidth: "50%", fontSize: "120%" }}
              >
                <span className="bolder">{t("header.deadline")}</span>{" "}
                {t("header.deadline2")}
              </p>
              <p style={{ maxWidth: "40%", fontSize: "120%" }}>
                {t("header.questions")}
                <a
                  href="mailto:email@example.com"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <u>{t("header.questionsMail")}</u>
                </a>
                {t("header.questionsMail2")}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
